/* eslint-disable react/jsx-no-target-blank */

import React from 'react';
import css from './Credit.scss';

const Credit = () => (
	<a href="https://storycards.com" target="_blank" title="Storycards" className={css.credit}>
		<span className={css.text}>Created on storycards</span>
	</a>
);

export default Credit;
